module.exports = __webpack_public_path__ + "img/2S.54957ffe.png";